import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'

let useStyles = makeStyles((theme) => ({
  previewWrapper: {
    position: 'relative',
  },
  minImg: {
    cursor: 'pointer',
  },
  previewImg: {
    position: 'absolute',
    maxWidth: 300,
    maxHeight: 300,
    padding: 5,
    backgroundColor: '#fff',
    border: '1px solid #e5e5e5',
    top: '100%',
    left: '100%',
    zIndex: 999,
    [theme.breakpoints.down('md')]: {
      maxWidth: 200,
      maxHeight: 200,
      left: '50%',
    },
  },
  previewProfileMobile: {
    position: 'absolute',
    maxWidth: 300,
    maxHeight: 300,
    padding: 5,
    backgroundColor: '#fff',
    bottom: '10px',
    left: '100%',
    zIndex: 999,
    [theme.breakpoints.down('md')]: {
      maxWidth: 200,
      maxHeight: 200,
    },
  },
}))

export default (props) => {
  let { src, children, srcProfileMobile } = props
  const styleClass = useStyles()

  let [isPreview, setIsPreview] = useState(false)

  let handleMouseEnter = () => {
    setIsPreview(true)
  }

  let handleMouseLeave = () => {
    setIsPreview(false)
  }

  return (
    <div className={styleClass.previewWrapper}>
      <div
        className={src || srcProfileMobile ? styleClass.minImg : ''}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
      {isPreview && src && (
        <img src={src} className={styleClass.previewImg} alt="previewImg" />
      )}
      {isPreview && srcProfileMobile && (
        <img
          src={srcProfileMobile}
          className={styleClass.previewProfileMobile}
          alt="previewProfileMobile"
        />
      )}
    </div>
  )
}
